export default __webpack_public_path__ + "static/media/MM CPC Press Release 2018 06 14_Final.97866720.pdf";